// BeforeAfterSlider.jsx
import React, { useState, useRef } from 'react'
import config from '../../config/config'

const BeforeAfterSlider = ({ item }) => {
  const [sliderValue, setSliderValue] = useState(15)
  const containerRef = useRef(null)
  const isDragging = useRef(false)

  const beforeUrl = `${config.beforeAfter}${item.id}/before.jpg`
  const afterUrl = `${config.beforeAfter}${item.id}/after.jpg`

  const update = (clientX) => {
    const rect = containerRef.current.getBoundingClientRect()
    let pct = ((clientX - rect.left) / rect.width) * 100
    pct = Math.max(0, Math.min(100, pct))
    setSliderValue(pct)
  }

  const onMouseDown = (e) => {
    isDragging.current = true
    update(e.clientX)
  }
  const onMouseMove = (e) => {
    if (isDragging.current) update(e.clientX)
  }
  const onMouseUp = () => {
    isDragging.current = false
  }

  const onTouch = (e) => {
    if (e.touches[0]) update(e.touches[0].clientX)
  }

  return (
    <div
      className="block-wrapper"
      style={{ width: '100%', textAlign: 'center' }}
    >
      <div
        className="before-after-container"
        ref={containerRef}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
        onTouchMove={onTouch}
        onTouchStart={onTouch}
        style={{ '--slider-percent': `${sliderValue}%` }}
      >
        <img src={beforeUrl} alt="before" className="before-img" />
        <div className="after-img-wrapper">
          <img src={afterUrl} alt="after" className="after-img" />
        </div>
        <div
          className="slider-handle"
          onMouseDown={onMouseDown}
          onTouchStart={onTouch}
          style={{ left: `${sliderValue}%` }}
        >
          <div className="slider-circle" />
        </div>
      </div>
      <p style={{ fontStyle: 'italic' }} className="before-after-label">
        {item.labelFr}
      </p>
    </div>
  )
}

export default BeforeAfterSlider
